import {State} from '../../types'

export const addToCheckProcessedColumn = (state: State, key: string): void => {
  const origKey = state.columnTitlesMap[key]
  state.processedColumns.push(origKey || key)
}
